import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

// Mirrors the id portal footer: a fixed brand bar showing the copyright + app version.
// Version comes from REACT_APP_VERSION (set per environment in CI), falling back to "dev".
const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    padding: "6px 0",
    backgroundColor: "rgba(42, 6, 81, 0.85)", // brand primary (#2A0651), matching the id portal
    color: "rgba(255, 255, 255, 0.7)",
    // Full page width, above the sidebar/topbar so the bar spans the whole bottom edge.
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const Footer = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <footer {...rest} className={clsx(classes.root, className)}>
      <Typography variant="caption">
        &copy; Didimo &middot; v{APP_VERSION}
      </Typography>
    </footer>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
